/**
 * Which practice the schedule board draws, given the workspace and the URL.
 *
 * One practice at a time: fourteen rooms already scroll sideways, and each
 * location keeps its own timezone while the board has one time axis. The URL is
 * the only source of truth, so nothing is stored and nothing goes stale.
 */

export type ScheduleLocation = { id: string; name: string }

export type LocationChoice = { kind: `draw`; locationId: string } | { kind: `ask` } | { kind: `none` }

export function chooseLocation(locations: ScheduleLocation[], requested?: string | null): LocationChoice {
  if (!locations.length) return { kind: `none` }
  if (requested && locations.some((location) => location.id === requested)) {
    return { kind: `draw`, locationId: requested }
  }
  // One practice is not a choice, so an id this workspace does not have is
  // corrected in what gets drawn. Nothing rewrites the URL, so that id stays in
  // the address bar.
  if (locations.length === 1) return { kind: `draw`, locationId: locations[0].id }
  return { kind: `ask` }
}
